<template>
  <div>
    <div class="mint-nft-class" v-if="shouldShowMintNftStepper">
      <stepper :steps="currentStepsArray" v-if="selectedFile.type"></stepper>
      <img
        src="@/Common/Icons/cloudsCardanoMint.png"
        class="cardano-cloud-mint-img"
      />
      <div class="mint-nft-background" :style="backgroundImage"></div>
      <div class="mint-nft-content">
        <div class="form-wrapper">
          <base-form
            id="mint-nft"
            method="post"
            :schema="currentStepsArray[currentStep - 1].scheme"
            :handleSubmit="validateAndSubmit"
          >
            <component :is="currentStepsArray[currentStep - 1].component" />
          </base-form>
        </div>
      </div>
    </div>
    <preview-modal
      v-else
      :handleSubmit="handleSubmit"
      :txHash="txHash"
    ></preview-modal>
  </div>
  <connect-and-polygon-modal v-if="isBeginConnectionModalOpen" />
</template>
<script>
import { useStore } from "vuex";
import { computed, onMounted, ref } from "vue";
import Stepper from "@/components/Stepper.vue";
import BaseForm from "@/components/BaseForm.vue";
import useMinting from "@/composables/useMinting";
import PreviewModal from "@/components/PreviewModal";
import ConnectAndPolygonModal from "@/components/ConnectAndPolygonModal";
import MintDetails from "@/components/MintNft/MintDetails";
import MintNftFile from "@/components/MintNft/MintNftFile";
import MintCoverImage from "@/components/MintNft/MintCoverImage";
import MintDescription from "@/components/MintNft/MintDescription";
import { eventBus } from "../main";

export default {
  name: "CardanoMintNft",
  components: {
    Stepper,
    BaseForm,
    MintDetails,
    MintNftFile,
    PreviewModal,
    MintCoverImage,
    MintDescription,
    ConnectAndPolygonModal,
  },
  setup() {
    const store = useStore();
    const errorsNfts = computed(() => store.getters["nfts/getErrors"]);
    eventBus.emit("custom-event");
    // (async () => {
    //   const nami_lib = await import("nami-wallet-api");
    //   const Nami = await nami_lib.NamiWalletApi(
    //     window.cardano //nami wallet object
    //     // "<blockfrost-api-key>"
    //   );
    //   await Nami.enable();
    //   let address = await Nami.getAddress();
    //   console.log("Nami Wallet Address:", address);
    //   eventBus.emit('custom-event')
    // })();

    const {
      mintNft,
      currentStep,
      selectedFile,
      incrementStep,
      backgroundUrl,
      currentStepsArray,
      hideMintNftStepper,
      shouldShowMintNftStepper,
      isBeginConnectionModalOpen,
    } = useMinting(store);

    const txHash = ref("");

    const fileType = (file) => file.type?.split("/")[0];
    const handleSubmit = async () => {
      txHash.value = await mintNft(errorsNfts);
    };
    const validateAndSubmit = () => {
      currentStep.value === currentStepsArray.value.length
        ? hideMintNftStepper()
        : incrementStep();
    };
    const backgroundImage = computed(() => {
      return backgroundUrl.value !== ""
        ? `background: linear-gradient(rgba(0, 51, 173, 0.3),rgba(0, 51, 173, 0.3)) , url(${backgroundUrl.value}) no-repeat center center/cover`
        : "";
    });
    onMounted(() => {
      console.log("Route innn");

      if (!isBeginConnectionModalOpen.value) {
        store.dispatch("minting/resetState");
        eventBus.emit("clearFile:selectedFile");
      }
    });
    return {
      txHash,
      fileType,
      currentStep,
      selectedFile,
      handleSubmit,
      incrementStep,
      shouldShowMintNftStepper,
      currentStepsArray,
      validateAndSubmit,
      backgroundUrl,
      backgroundImage,
      isBeginConnectionModalOpen,
    };
  },
};
</script>
<style lang="scss" scoped src="@/Common/Styles/cardanoMintNft.scss"></style>
